export const ImageGenerateMode = {
    BUSINESS: 'business',
    FREE: 'free',
  }

export const ImageStyleMode = {
    AI: 'AI',
    HUMAN: 'HUMAN',
  }

  
export const PaymentType = {
    We_CHAT: 'wechat',
    ALI_PAY: 'alipay',
    STRIPE: 'stripe',
  }